import React from 'react';
import { useParams } from 'react-router';
// import s from './ProductDetailPageView.module.css';
import armchairs from '../../JSON/detailedArmchairs.json';
import mouses from '../../JSON/detailedMouses.json';
import headphones from '../../JSON/detailedHeadphones.json';
import DetailedProduct from '../../components/DetailedProduct/DetailedProduct';
import cameras from '../../JSON/detailedCameras.json';
import mousepads from '../../JSON/detailedMousepads.json';
import laptopcolds from '../../JSON/detailedLaptopcolds.json';
import keyboards from '../../JSON/detailedKeyboards.json';
import gamepads from '../../JSON/detailedGamepads.json';
import triggers from '../../JSON/detailedTriggers.json';

const whatDataToTake = productName => {
  switch (productName) {
    case 'armchair':
      return armchairs;

    case 'mice':
      return mouses;

    case 'headphone':
      return headphones;

    case 'cam':
      return cameras;

    case 'mousepads':
      return mousepads;

    case 'laptopcold':
      return laptopcolds;

    case 'keyboards':
      return keyboards;

    case 'gamepads':
      return gamepads;

    case 'triggers':
      return triggers;

    default:
      return;
  }
};

function ProductDetailPageView() {
  const { product, productId } = useParams();
  const numberedId = Number(productId);
  const dataAll = whatDataToTake(product);
  const dataToRender = dataAll.find(el => el.id === numberedId);

  return (
    <>
      <DetailedProduct info={dataToRender} id={numberedId} product={product} />
    </>
  );
}

export default ProductDetailPageView;
